const MAX_PAGES = 20;
const DEBOUNCE_MS = 150;

const root = document.querySelector('[data-hd-library-search]');
const input = root?.querySelector('[data-hd-library-input]');
const status = root?.querySelector('[data-hd-library-status]');
const grid = document.querySelector('[data-hd-autoload]');

if (root && input && grid) {
  const countEl = document.querySelector('[data-hd-count]');
  const originalCount = countEl ? countEl.textContent : '';
  const total = parseInt(grid.dataset.total || '0', 10);

  const here = new URL(window.location.href);
  const pageParam = here.searchParams.get('page');
  const onFirstPage = !pageParam || pageParam === '1';

  let loaded = onFirstPage && !grid.dataset.next;
  let loading = null;
  let empty = null;
  let timer;

  const plural = (n) => (n === 1 ? 'product' : 'products');

  const say = (text) => {
    if (!status) return;
    status.textContent = text;
    status.hidden = !text;
  };

  const keyOf = (li) => (li.querySelector('a[href]')?.getAttribute('href') || '').split('?')[0];

  const textOf = (li) => {
    if (!li.dataset.hdLibText) {
      li.dataset.hdLibText = li.textContent.replace(/\s+/g, ' ').toLowerCase();
    }
    return li.dataset.hdLibText;
  };

  const dedupe = () => {
    const seen = new Set();
    Array.from(grid.children).forEach((li) => {
      const key = keyOf(li);
      if (!key) return;
      if (seen.has(key)) li.remove();
      else seen.add(key);
    });
  };

  const retirePaging = () => {
    document.querySelector('[data-hd-pagination]')?.remove();
    document.querySelector('.hd-perpage')?.remove();
    const wrap = document.querySelector('[data-hd-loadmore-wrap]');
    if (wrap) wrap.hidden = true;
  };

  const firstPageUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('lq');
    return url.toString();
  };

  const loadAll = () => {
    if (loaded) return Promise.resolve();
    if (loading) return loading;

    loading = (async () => {
      let next = onFirstPage ? grid.dataset.next : firstPageUrl();
      let pages = 0;
      while (next && pages < MAX_PAGES) {
        pages += 1;
        const res = await fetch(next, { headers: { 'X-Requested-With': 'fetch' } });
        if (!res.ok) throw new Error(String(res.status));
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const frag = document.createDocumentFragment();
        doc.querySelectorAll('[data-hd-autoload] > li').forEach((li) => frag.appendChild(li));
        grid.appendChild(frag);
        next = doc.querySelector('[data-hd-autoload]')?.dataset.next || null;
      }
      loaded = true;
      dedupe();
      retirePaging();
    })().catch(() => {
      loading = null;
      say('Could not load the whole library. Please reload the page and try again.');
    });

    return loading;
  };

  const setEmpty = (on) => {
    if (on && !empty) {
      empty = document.createElement('p');
      empty.className = 'hd-collection__empty';
      grid.after(empty);
    }
    if (!empty) return;
    empty.hidden = !on;
    if (on) {
      empty.textContent = `No library darts match “${input.value.trim()}”. Try a brand, a model name or a weight.`;
    }
  };

  const apply = () => {
    const query = input.value.trim();
    const words = query.toLowerCase().split(/\s+/).filter(Boolean);
    const cards = Array.from(grid.children);

    let shown = 0;
    cards.forEach((li) => {
      const match = !words.length || words.every((word) => textOf(li).includes(word));
      li.hidden = !match;
      if (match) shown += 1;
    });

    if (!words.length) {
      say('');
      setEmpty(false);
      if (countEl) countEl.textContent = loaded ? `${cards.length} ${plural(cards.length)}` : originalCount;
      return;
    }

    if (countEl) countEl.textContent = `${shown} of ${loaded ? cards.length : total} ${plural(total)}`;
    if (loaded) {
      say(`${shown} library ${shown === 1 ? 'dart matches' : 'darts match'} “${query}”.`);
    } else {
      say('Searching the whole library…');
    }
    setEmpty(loaded && shown === 0);
  };

  const syncUrl = () => {
    const url = new URL(window.location.href);
    const query = input.value.trim();
    if (query) url.searchParams.set('lq', query);
    else url.searchParams.delete('lq');
    window.history.replaceState(window.history.state, '', url);
  };

  const run = async () => {
    if (input.value.trim()) {
      apply();
      await loadAll();
    }
    apply();
    syncUrl();
  };

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, DEBOUNCE_MS);
  });

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && input.value) {
      input.value = '';
      run();
    }
  });

  new MutationObserver(() => {
    dedupe();
    if (loaded) retirePaging();
    if (input.value.trim()) apply();
  }).observe(grid, { childList: true });

  const initial = here.searchParams.get('lq');
  if (initial) {
    input.value = initial;
    run();
  }
}
